import React from "react";
import { StatusType } from "./types";
const StatusContext = React.createContext<StatusType>({ loading: true });

export const StatusProvider = StatusContext.Provider;
export const StatusConsumer = StatusContext.Consumer;

export default StatusContext;
